export interface Message {
  id: string;
  createdAt: number;
  updatedAt: number;
  conversationId: string;
  senderId: string;
  senderName: string;
  content: string;
  attachments?: Attachment[];
  replyTo?: ReplyTo;
  seenBy?: SeenBy[];
}

export interface MessageOverEvent extends Message {
  actionUrl: string;
  image: string;
}

export interface MessageCreate {
  conversationId: string;
  senderId: string;
  senderName: string;
  content: string;
  attachments?: Attachment[];
  replyTo?: string;
}

export interface Attachment {
  type: string;
  url: string;
  fileName: string;
  fileSize: number;
  contentType: string;
  messageId: string;
}

export interface ReplyTo {
  messageId: string;
  content: string;
  senderId: string;
  senderName: string;
}

export interface SeenBy {
  userId: string;
  seenAt: number;
}

export function isMessageOverEvent(data: any): boolean {
  return (
    data &&
    typeof data === "object" &&
    "senderId" in data &&
    "actionUrl" in data
  );
}
